__turbopack_context__.v({
  "content": "GalleryGrid-module-scss-module__ObNXCa__content",
  "filterClosed": "GalleryGrid-module-scss-module__ObNXCa__filterClosed",
  "gridContainer": "GalleryGrid-module-scss-module__ObNXCa__gridContainer",
  "header": "GalleryGrid-module-scss-module__ObNXCa__header",
  "mobileView": "GalleryGrid-module-scss-module__ObNXCa__mobileView",
  "noTopMargin": "GalleryGrid-module-scss-module__ObNXCa__noTopMargin",
});
